import { render, staticRenderFns } from "./MySpinner.vue?vue&type=template&id=68854f84&scoped=true&"
import script from "./MySpinner.vue?vue&type=script&lang=js&"
export * from "./MySpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68854f84",
  null
  
)

export default component.exports